import React from 'react';

import { useLatestPerformance } from '../api/indexPerformanceApi';
import { AssetTable } from './AssetTable';

export const PerformanceDashboard: React.FC = () => {
  // React Query owns the fetch lifecycle (auth via the shared apiClient,
  // caching, dedupe, background refetch). This mirrors the treasury-curve
  // sibling and swaps out the roadmap's raw useEffect/fetch.
  const { data, isLoading, isError, error } = useLatestPerformance();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        <span className="ml-3 text-gray-500 font-medium">
          Loading market snapshot...
        </span>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg dark:bg-red-900/20 dark:border-red-800 dark:text-red-300">
        <strong>Error: </strong>
        {error instanceof Error
          ? error.message
          : 'An unexpected error occurred.'}
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="space-y-8">
      {/* Header */}
      <header>
        <h2 className="section-title">Global Market Performance</h2>
        <p className="muted text-sm mt-1">
          {/* Last background-worker snapshot timestamp. */}
          {data.indices.length > 0 && (
            <span className="block mt-0.5">
              Last updated:{' '}
              {new Date(data.indices[0].time).toLocaleString()}
            </span>
          )}
        </p>
      </header>

      {/* Global Indices */}
      <section>
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
          Global Indices
        </h3>
        <AssetTable data={data.indices} />
      </section>

      {/* Commodities & Crypto */}
      <section>
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
          Commodities &amp; Crypto
        </h3>
        <AssetTable data={data.commodities_crypto} />
      </section>
    </div>
  );
};
